module.exports = __webpack_public_path__ + "leftHover.7fe757c1.png";